import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Logout } from '../../../../store/actions/AuthActions';

const ExpiredPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    return (
        <Container fluid className="h-100 mt-5 pt-5">
            <Row className="justify-content-center align-items-center h-100">
                <Col md={6}>
                    <Card className="shadow-sm border-danger">
                        <Card.Body className="p-5 text-center">
                            <h2 className="text-danger mb-4">Rinnovo automatico non riuscito</h2>
                            <p className="mb-4 text-muted">
                                Il rinnovo automatico dell'abbonamento non è andato a buon fine. La tua carta di credito potrebbe essere scaduta o avere fondi insufficienti.
                            </p>
                            <p className="mb-5 text-muted">
                                Puoi sottoscrivere un nuovo abbonamento direttamente qui sotto oppure contattare il supporto per assistenza.
                            </p>
                            <Button
                                variant="primary"
                                size="lg"
                                className="w-100 mb-3"
                                onClick={() => navigate('/abbonamento', { replace: true })}
                            >
                                Sottoscrivi un nuovo abbonamento
                            </Button>
                            <Button
                                variant="outline-secondary"
                                size="lg"
                                className="w-100"
                                href="mailto:supporto@sportid.it"
                            >
                                Contatta il supporto
                            </Button>
                            {/* Senza questo si resta bloccati qui: la pagina è fuori
                                dal layout, quindi il logout del menu non è raggiungibile. */}
                            <Button
                                variant="link"
                                className="w-100 mt-3 text-muted text-decoration-none"
                                onClick={() => dispatch(Logout(navigate))}
                            >
                                Esci
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ExpiredPage;